import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { useAsync } from '@src/redux/hooks/useAsync';
import {
  SET_STEPPER,
  SET_STEP,
  SET_CURRENT_STEP,
  SET_COMPLETE_STEP,
  RESET_STEP,
} from './constants';
import {
  setStepper,
  setStep,
  setCurrentStep,
  setCompleteStep,
  resetStep,
} from './actions';

const stepperSelector = (state) => {
  return state.stepper;
};

export const useOnStepper = {
  state: () => {
    return useSelect(stepperSelector);
  },
  actions: () => {
    return {
      setStepper: useAction(setStepper, {
        saga: useAsync(SET_STEPPER),
      }),
      setStep: useAction(setStep, {
        saga: useAsync(SET_STEP),
      }),
      setCurrentStep: useAction(setCurrentStep, {
        saga: useAsync(SET_CURRENT_STEP),
      }),
      setCompleteStep: useAction(setCompleteStep, {
        saga: useAsync(SET_COMPLETE_STEP),
      }),
      resetStep: useAction(resetStep, {
        saga: useAsync(RESET_STEP),
      }),
    };
  },
};
